import styled from 'styled-components'

export const LoginHeaderWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 30px;
	margin-bottom: 35px;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 60px;
		height: 2px;
		background: linear-gradient(90deg, transparent, #4c6ef5, transparent);
		border-radius: 2px;
	}

	span {
		font-size: 32px;
		font-weight: 700;
		color: #ffffff;
		letter-spacing: -0.5px;
		text-transform: uppercase;
	}
`
